// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"edbf2aea","885":"edbf2aea","1575":"edbf2aea","5846":"edbf2aea","8099":"edbf2aea"}[chunkId] + ".chunk.css";
};